
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"school-star_svg__Ebene_1","data-name":"Ebene 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21.18 20.53"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"school-star_svg__cls-1",attrs:{"d":"M3.98 17.58c-.33-.18-.59-.43-.78-.74s-.28-.65-.28-1.04V11L.52 9.67c-.18-.1-.32-.23-.4-.38s-.13-.32-.13-.5.04-.35.13-.5.22-.28.4-.38l8.46-4.58c.15-.08.3-.15.46-.19s.32-.06.49-.06.33.02.49.06.31.1.46.19l9.53 5.2c.17.08.3.2.39.36s.14.33.14.51v6.4c0 .28-.1.52-.29.71s-.43.29-.71.29-.52-.1-.71-.29-.29-.43-.29-.71V9.9l-2 1.1v4.8c0 .38-.09.73-.28 1.04s-.44.55-.78.74l-5 2.7c-.15.08-.3.15-.46.19s-.32.06-.49.06-.33-.02-.49-.06-.31-.1-.46-.19l-5-2.7zm5.95-5.08l6.85-3.7-6.85-3.7-6.85 3.7 6.85 3.7zm0 6.03l5-2.7v-3.78l-4.03 2.23a2.002 2.002 0 01-.98.25c-.17 0-.33-.02-.5-.06s-.33-.1-.48-.19l-4.03-2.23v3.78l5 2.7zM17.51 4.61l-1.69.47c-.08.02-.15.02-.22 0s-.13-.06-.17-.11a.508.508 0 01-.09-.18c-.02-.07 0-.13.03-.2l.79-1.49-1.05-1.39a.325.325 0 01-.01-.39c.04-.06.09-.1.14-.12s.13-.04.22-.03l1.77.29L18.27.13a.36.36 0 01.38-.12c.06.02.13.05.18.1s.09.11.1.19l.3 1.66 1.7.57c.08.03.14.07.18.12s.06.11.07.18a.308.308 0 01-.18.33l-1.58.74v1.68c0 .08-.02.14-.07.19s-.1.09-.16.12-.13.03-.2.02-.14-.05-.19-.1L17.52 4.6z"}})])
          )
        }
      }
    